/*eslint-disable*/
import { createContext, useEffect, useReducer } from 'react';
import type { FC, ReactNode } from 'react';
import PropTypes from 'prop-types';
/* import axios from '../lib/axios'; */
import axios from 'axios';
import { verify, JWT_SECRET } from '../utils/jwt';
import { postConexion, getConexion } from '../conexion/Conexion';

interface State {
  isInitialized: boolean;
  isAuthenticated: boolean;
  user: any | null;
}

interface AuthContextValue extends State {
  platform: 'JWT';
  login: (
    email: string,
    password: string,
    isProveedor: Boolean
  ) => Promise<void>;
  logout: () => Promise<void>;
  register: (objUser: any) => Promise<void>;
  verifyEmail: (email: string, proveedor: Boolean) => Promise<void>;
  resetPassword: (objUser: any) => Promise<void>;
  setPassword: (objUser: any) => Promise<void>;
  setPasswordUser: (objUser: any) => Promise<void>;
}

interface AuthProviderProps {
  children: ReactNode;
}

type InitializeAction = {
  type: 'INITIALIZE';
  payload: {
    isAuthenticated: boolean;
    user: any | null;
  };
};

type LoginAction = {
  type: 'LOGIN';
  payload: {
    user: any;
  };
};

type LogoutAction = {
  type: 'LOGOUT';
};

type RegisterAction = {
  type: 'REGISTER';
  payload: {
    user: any;
  };
};

type Action = InitializeAction | LoginAction | LogoutAction | RegisterAction;

const initialState: State = {
  isAuthenticated: false,
  isInitialized: false,
  user: null,
};

const setSession = (accessToken: string | null): void => {
  if (accessToken) {
    localStorage.setItem('accessToken', accessToken);
    /* axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`; */
    axios.defaults.headers.common.Authorization = accessToken;
  } else {
    localStorage.removeItem('accessToken');
    delete axios.defaults.headers.common.Authorization;
  }
};

const handlers: Record<string, (state: State, action: Action) => State> = {
  INITIALIZE: (state: State, action: InitializeAction): State => {
    const { isAuthenticated, user } = action.payload;

    return {
      ...state,
      isAuthenticated,
      isInitialized: true,
      user,
    };
  },
  LOGIN: (state: State, action: LoginAction): State => {
    const { user } = action.payload;

    return {
      ...state,
      isAuthenticated: true,
      user,
    };
  },
  LOGOUT: (state: State): State => ({
    ...state,
    isAuthenticated: false,
    user: null,
  }),
  REGISTER: (state: State, action: RegisterAction): State => {
    const { user } = action.payload;

    return {
      ...state,
      isAuthenticated: true,
      user,
    };
  },
};

const reducer = (state: State, action: Action): State =>
  handlers[action.type] ? handlers[action.type](state, action) : state;

const AuthContext = createContext<AuthContextValue>({
  ...initialState,
  platform: 'JWT',
  login: () => Promise.resolve(),
  logout: () => Promise.resolve(),
  register: () => Promise.resolve(),
  verifyEmail: () => Promise.resolve(),
  resetPassword: () => Promise.resolve(),
  setPassword: () => Promise.resolve(),
  setPasswordUser: () => Promise.resolve(),
});

export const AuthProvider: FC<AuthProviderProps> = (props) => {
  const { children } = props;
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    const initialize = async (): Promise<void> => {
      try {
        const accessToken = window.localStorage.getItem('accessToken');

        if (accessToken && verify(accessToken, JWT_SECRET)) {
          setSession(accessToken);
          const isProveedor = localStorage.getItem('isProvider');
          if (
            isProveedor !== null &&
            isProveedor !== undefined &&
            isProveedor !== 'undefined'
          ) {
            /* const response = await axios.get<{ user: any }>('/api/identity/me');
          const { user } = response.data; */
            const reponse_user = await getConexion('/proveedor/me');

            dispatch({
              type: 'INITIALIZE',
              payload: {
                isAuthenticated: true,
                user: {
                  businessId: { firstStep: false, ...reponse_user.businessId },
                  avatar:
                    '/static/mock-images/avatars/avatar-jane_rotanson.png',
                  email: reponse_user.email,
                  id: '5e86809283e28b96d2d38537',
                  name: reponse_user.nombre,
                  plan: 'Premium',
                  rol: reponse_user.rolId.rol_type,
                  ...reponse_user,
                },
              },
            });
          } else {
            const reponse_user = await getConexion('users/me');
            const { user, signedContratUrl, contractData } = reponse_user;

            localStorage.setItem('rolUser', user.rolDesc);
            if (!user.isAdminUser) {
              localStorage.setItem('bussinessId', user.businessId.business_id);
            }
            dispatch({
              type: 'INITIALIZE',
              payload: {
                isAuthenticated: true,
                user: {
                  avatar:
                    '/static/mock-images/avatars/avatar-jane_rotanson.png',
                  email: user.email,
                  id: '5e86809283e28b96d2d38537',
                  name: user.firstName + ' ' + user.lastName,
                  plan: 'Premium',
                  rol: user.rolDesc,
                  signedContratUrl,
                  firstStepContract: contractData?.props,
                  ...user,
                },
              },
            });
          }
        } else {
          dispatch({
            type: 'INITIALIZE',
            payload: {
              isAuthenticated: false,
              user: null,
            },
          });
        }
      } catch (err) {
        console.error(err);
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null,
          },
        });
      }
    };

    initialize();
  }, []);

  const login = async (
    email: string,
    password: string,
    isProveedor
  ): Promise<void> => {
    localStorage.setItem('isProvider', isProveedor);
    const obj = {
      email: '',
      password: password,
      isProveedor: isProveedor,
      ruc: '',
    };
    obj.email = email;
    delete obj.ruc;
    const response = await postConexion('users/login', obj);
    const { accessToken } = response;

    /* const response = await axios.post<{ accessToken: string; user: any }>('/api/authentication/login', {
      email,
      password
    });
    const { accessToken, user } = response.data; */

    setSession(accessToken);
    if (isProveedor === true) {
      delete obj.password;
      const reponse_user = await getConexion('/proveedor/me');
      dispatch({
        type: 'LOGIN',
        payload: {
          user: {
            businessId: { firstStep: false, ...reponse_user.businessId },
            avatar: '/static/mock-images/avatars/avatar-jane_rotanson.png',
            email: reponse_user.email,
            id: '5e86809283e28b96d2d38537',
            name: reponse_user.nombre,
            plan: 'Premium',
            rol: reponse_user.rolId.rol_type,
            ...reponse_user,
          },
        },
      });
    } else {
      const reponse_user = await getConexion('users/me');
      const { user, signedContratUrl, contractData } = reponse_user;
      localStorage.setItem('onboarding', user.onboarding);

      dispatch({
        type: 'LOGIN',
        payload: {
          user: {
            avatar: '/static/mock-images/avatars/avatar-jane_rotanson.png',
            email: user.email,
            id: '5e86809283e28b96d2d38537',
            name: user.firstName + ' ' + user.lastName,
            plan: 'Premium',
            rol: user.rolDesc,
            onboarding: user.onboarding,
            signedContratUrl,
            firstStepContract: contractData?.props,
            ...user,
          },
        },
      });
    }
  };

  const logout = async (): Promise<void> => {
    const accessToken = window.localStorage.getItem('accessToken');
    if (accessToken !== null) {
      await postConexion('users/logout', '');
      setSession(null);
      dispatch({ type: 'LOGOUT' });
    } else {
      window.location.reload();
    }
  };

  const verifyEmail = async (
    email: string,
    proveedor: Boolean
  ): Promise<void> => {
    if (proveedor) {
      const obj = {
        ruc: email,
      };
      await postConexion('proveedor/set-password-mail', obj);
      dispatch({ type: 'LOGOUT' });
    } else {
      const obj = {
        email: email,
      };
      await postConexion('users/reset-password-mail', obj);
      dispatch({ type: 'LOGOUT' });
    }
  };

  const register = async (objUser: any): Promise<void> => {
    delete objUser['submit'];
    await postConexion('users', objUser);
  };

  const resetPassword = async (objUser: any): Promise<void> => {
    await postConexion('users/reset-password', objUser);
  };

  const setPassword = async (objUser: any): Promise<void> => {
    await postConexion('proveedor/set-password', objUser);
  };

  const setPasswordUser = async (objUser: any): Promise<void> => {
    await postConexion('users/reset-password', objUser);
  };

  return (
    <AuthContext.Provider
      value={{
        ...state,
        platform: 'JWT',
        login,
        logout,
        register,
        verifyEmail,
        resetPassword,
        setPassword,
        setPasswordUser,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AuthContext;
